// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1vxyP","inner":"Footer_inner__2c3cA"};